import Enums from 'utils/EnumsManager';

// formated Option List

const { FieldTypes } = Enums;
const { Lookup, PickList } = FieldTypes;

const formatSiderOptions = (options, fieldType) => {
  const optionsCopy = _.cloneDeep(options);
  let formatOptions = [];
  if (fieldType === Lookup) {
    formatOptions = optionsCopy.map(opt => ({
      label: opt.name,
      value: opt.id
    }));
  }
  if (fieldType === PickList) {
    formatOptions = optionsCopy.map(opt => ({
      label: opt.option_value,
      value: opt.id
    }));
  }
  return formatOptions;
};

export { formatSiderOptions };



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria__REFACTORED/utils/criterialUtils.js